module.exports = __webpack_public_path__ + "static/img/coins.373c7438.png";